import { useLocation } from 'react-router-dom';

import { withErrorBoundary } from '../../components/ErrorBoundary';
import AuthCheckWrapper from '../AuthCheckWrapper';

import { StyledContainer } from './StyledComponents';
import CoverageLevelSelection from '../../components/rentGuarantee/CoverageLevelSelection';

const RentGuaranteeManagePoliciesPage = () => {
  const location = useLocation();
  const parts = location.pathname.split('/');
  const propertyId = parts[4];

  return (
    <AuthCheckWrapper>
      <StyledContainer>
        <CoverageLevelSelection listingAlias={propertyId} data-test="coverage-selection" />
      </StyledContainer>
    </AuthCheckWrapper>
  );
};

export { RentGuaranteeManagePoliciesPage };
export default withErrorBoundary(RentGuaranteeManagePoliciesPage);
